import React from 'react'

import Modal from '../../common/components/Modal'

const ResetPasswordModal = props => {
  const { onClose, onReset, user } = props
  return <Modal
    cancelModal={onClose}
    saveAction={<button className="btn btn-danger" onClick={onReset}>
      <i className="fa fa-trash-can" /> Reset Password
    </button>}>
    <Modal.Header>
      Send Reset Password Request
    </Modal.Header>
    <Modal.Body>
      <div className="alert alert-danger">
          <p>Are you sure you'd like to reset the password for <strong>{user.email}</strong>?</p>
          <p>This will send a reset-password link to that email.</p>
      </div>
    </Modal.Body>
    <Modal.Footer />
  </Modal>
}

export default ResetPasswordModal
